import { Link } from 'react-router-dom';

const relations = [
  {
    icon: 'ri-vip-crown-line',
    question: 'Кадровый резерв отвечает на вопрос',
    answer: 'Кого мы потенциально готовим к будущей роли?',
  },
  {
    icon: 'ri-file-list-3-line',
    question: 'ИПР отвечает на вопрос',
    answer: 'Что конкретно этому сотруднику необходимо развить?',
  },
  {
    icon: 'ri-graduation-cap-line',
    question: 'Обучение отвечает на вопрос',
    answer: 'Как мы поможем развить необходимые компетенции?',
  },
  {
    icon: 'ri-user-heart-line',
    question: 'Наставничество отвечает на вопрос',
    answer: 'Кто поможет сотруднику применять знания и учиться на практике?',
  },
];

export default function TalentPoolAndIPR() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Кадровый резерв и ИПР
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-12">
          Почему эти инструменты должны работать вместе
        </p>

        <div className="space-y-4 mb-12">
          {relations.map((r, i) => (
            <div key={i} className="flex items-start gap-4 bg-white rounded-xl border border-gray-200 p-5 hover:border-teal-200 transition-colors">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">{r.question}</p>
                <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed">{r.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/razvitie-personala/otsenka-i-razvitie-sotrudnikov" className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Оценка и развитие сотрудников
          </Link>
          <Link to="/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov" className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Индивидуальный план развития
          </Link>
          <Link to="/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov" className="bg-white border border-gray-200 text-gray-700 px-5 py-2.5 rounded-lg text-sm font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            Наставничество и развитие сотрудников
          </Link>
        </div>
      </div>
    </section>
  );
}